module.exports = __webpack_public_path__ + "static/assets/mastercard.90eb153.png";